var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"score-return-link",attrs:{"to":"/score"}},[_vm._v("返回积分商城")])}
var staticRenderFns = []

export { render, staticRenderFns }